import { useState, useEffect, useRef } from 'react';

export function useStateRef<T>(initialValue: T) {
  const [value, setValue] = useState(initialValue);
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return { setValue, ref, value };
}
